var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapLocationInput"},[_c('map-container',{attrs:{"location":_vm.location},on:{"change":_vm.emitChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }